import AxiosFactory from '@/entities/security/AxiosFactory'
import ApiErrorFactory from '@/entities/errors/api_errors/ApiErrorsFactory'
import { GET_COUNTRIES_LIST_URL, GET_CURRENCIES_LIST_URL, REGISTER_USER_URL } from '@/modules/register/endpoints'
import { RegisterUserPayloadI } from '@/modules/register/types/api/RegisterUser'

export default class RegisterApi {
  async registerUser(data: RegisterUserPayloadI) {
    try {
      const response = await AxiosFactory.createAxiosInstance().post(REGISTER_USER_URL, data)
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }
  async loadCurrenciesList() {
    try {
      const response = await AxiosFactory.createAxiosInstance().get(GET_CURRENCIES_LIST_URL)
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }
  async loadCountriesList() {
    try {
      const response = await AxiosFactory.createAxiosInstance().get(GET_COUNTRIES_LIST_URL)
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }
}
